/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Szoa206aResponseAblcomNg {
    /**
     * 廃止取次判断ＮＧ理由コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C403130」のユーザコードを設定
     */
    ablcomNgrsn?: string;
    /**
     * 廃止取次判断ＮＧ理由コード名称：全半角混在
     */
    ablcomNgrsnAname?: string;
}

